import { mapActions, mapGetters, mapMutations } from "vuex";
import { VueTelInput } from "vue-tel-input";
import { email, maxLength, required } from "vuelidate/lib/validators";
import { emailFormatter } from "@/mixins/validation";
import linkedAccountItem from "../../components/linked-account-item/index.vue";
import FacebookWidget from "@/components/widgets/facebook/index.vue";
import GoogleWidget from "@/components/widgets/google/index.vue";
import TooltipLayout from "@/components/atoms/tooltip-layout/index.vue";
import ContactsUpdate from "@/components/popups/contacts-update/index.vue";
import { seo } from "@/mixins/seo";
import _ from "lodash";

export default {
    name: "profile-contacts",
    mixins: [seo],
    data() {
        return {
            userContactsUpdate: {
                type: String,
                default: "phone",
            },

            phoneDialCode: "",
            payload: {
                email: "",
                phone: "",
            },

            isValidPhone: true,
            isVisiblePhoneConfirm: false,
            isVisibleEmailConfirm: false,
            copiedUser: {},
            validationErrors: {
                phone: [],
            },
        };
    },
    components: {
        VueTelInput,
        linkedAccountItem,
        FacebookWidget,
        GoogleWidget,
        TooltipLayout,
        ContactsUpdate,
    },
    created() {
        this.seo.title = this.$t(_.camelCase(this.$route.name));
    },
    mounted() {
        const copiedUser = _.cloneDeep(this.user);
        this.copiedUser = copiedUser;
        this.payload.phone = copiedUser?.phone;
        this.payload.email = copiedUser?.email;
    },
    validations() {
        if (this.userContactsUpdate === "email") {
            return {
                payload: {
                    email: {
                        required,
                        email: (val) => email(emailFormatter(val)),
                        maxLength: maxLength(50),
                    },
                },
            };
        }
    },
    computed: {
        ...mapGetters({
            user: "user/user",
            linkAccountRequest: "userContacts/linkAccountRequest",
            unlinkAccountRequest: "userContacts/unlinkAccountRequest",
            changePhoneRequestStatus: "userContacts/changePhoneRequestStatus",
            changeEmailRequestStatus: "userContacts/changeEmailRequestStatus",
            showPopupUserContacts: "userContacts/showPopupUserContacts",
        }),
        linkSocialAccount() {
            return [
                {
                    id: 1,
                    providerName: "Facebook",
                    provider: "facebook",
                    linkedLoading: () => {
                        if (this.linkAccountRequest.provider === "facebook") {
                            return this.linkAccountRequest.status;
                        }
                        return false;
                    },
                    unlinkedLoading: false,
                },
                {
                    id: 2,
                    providerName: "Google",
                    provider: "google",
                    linkedLoading: () => {
                        if (this.linkAccountRequest.provider === "google") {
                            return this.linkAccountRequest.status;
                        }
                        return false;
                    },
                    unlinkedLoading: false,
                },
            ];
        },
        emailErrors() {
            let error = [];
            if (!this.$v.payload.email.$dirty) {
                return error;
            }
            if (!this.$v.payload.email.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.email.email) {
                error.push(this.$t("validationEmail"));
            }
            if (!this.$v.payload.email.maxLength) {
                error.push(
                    this.$t("maxLengthField")
                        .replace(":field", this.$t("emailFieldShort"))
                        .replace(":count", 50)
                );
            }
            if (this.validationErrors.email) {
                this.validationErrors.email.forEach((row) => {
                    error.push(row);
                });
            }
            return error;
        },
    },
    methods: {
        ...mapActions({
            unlink: "userContacts/UNLINK_ACCOUNT",
            requestChangeContacts: "userContacts/SEND_REQUEST_CHANGE_CONTACTS",
            requestChangeContactsPhone: "userContacts/SEND_REQUEST_CHANGE_CONTACTS_PHONE",
            requestChangeContactsEmail: "userContacts/SEND_REQUEST_CHANGE_CONTACTS_EMAIL",
        }),
        ...mapMutations({
            changeShowPopupContacts: "userContacts/POPUP_USER_CONTACTS_CHANGE",
        }),
        changePhoneInput(number, info) {
            this.isValidPhone = info.valid;
            this.phoneDialCode = info.country.dialCode;
            if (this.copiedUser.phone !== info.number.e164.replace("+", "")) {
                this.isVisiblePhoneConfirm = true;
            } else {
                this.isVisiblePhoneConfirm = false;
            }
            if (this.isValidPhone) {
                // this.payload.phone = info.number.e164.replace(`+`, "");
                this.payload.phone = info.number.e164.replace(
                    `+${info.country.dialCode === "380" ? "38" : ""}`,
                    ""
                );
                this.validationErrors.phone = [];
            }
        },
        changeValidationPhone() {
            this.validationErrors.phone = [];
            if (this.payload.phone.length > 0) {
                if (!this.isValidPhone) {
                    this.validationErrors.phone.push(this.$t("enterCorrectPhone"));
                } else {
                    this.validationErrors.phone = [];
                }
            } else {
                this.validationErrors.phone.push(this.$t("validationRequired"));
            }
        },
        changePhoneCancel() {
            this.isValidPhone = true;
            this.validationErrors.phone = [];
            this.payload.phone = this.copiedUser.phone.replace(this.phoneDialCode, "");
            this.user.phone = this.copiedUser.phone;
            this.isVisiblePhoneConfirm = false;
        },
        submit(type) {
            if (type === "email") {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(this.payload.email)) {
                    return console.log("wrong");
                }
                // this.$v.$touch();
                // if (this.$v.$invalid) return;
            } else {
                this.changeValidationPhone();
                if (!this.isValidPhone) return;
            }
            // this.requestChangeContacts({
            //     field: type,
            //     value:
            //         type === "email"
            //             ? this.payload.email
            //             : `${this.phoneDialCode === "380" ? "38" : this.phoneDialCode}${
            //                   this.payload.phone
            //               }`,
            // }).then((response) => {
            //     if (response.data.data.field === "email") {
            //         this.$toasted.success(this.$t("successRequestChangeEmail"));
            //     } else {
            //         this.$toasted.success(this.$t("successRequestChangePhone"));
            //     }
            // });
            if (type === "phone") {
                this.requestChangeContactsPhone({
                    phone: `${this.phoneDialCode === "380" ? "38" : this.phoneDialCode}${
                        this.payload.phone
                    }`,
                }).then(() => {
                    this.$toasted.success(this.$t("successfullyChangedPhone"));
                });
            }
            if (type === "email") {
                this.requestChangeContactsEmail({ email: this.payload.email }).then(
                    () => {
                        this.$toasted.success(this.$t("successfullyChangedEmail"));
                    }
                );
            }
            if (type === "email") {
                this.isVisibleEmailConfirm = false;
            } else {
                this.isVisiblePhoneConfirm = false;
            }
        },
        unlinkAccount(provider) {
            const payload = {
                _method: "delete",
                ...this.getProvider(provider),
            };
            this.unlink(payload).then(() => {
                this.$toasted.success(this.$t("successUnlinkedAccount"));
            });
        },
        getProvider(provider) {
            if (this.copiedUser?.socials?.data.length > 0) {
                return this.copiedUser?.socials?.data.find(
                    (e) => e.provider === provider
                );
            }
        },
        onChangeEmail(event) {
            this.isVisibleEmailConfirm = true;
            this.payload.email = event.target.value;
        },

        changeEmailCancel() {
            this.payload.email = this.copiedUser.email;
            this.isVisibleEmailConfirm = false;
        },

        changePhone() {
            this.requestChangeContactsPhone({ phone: this.payload.phone }).then(() => {
                this.$toasted.success(this.$t("successRequestChangePhone"));
            });
            this.userContactsUpdate = "phone";
            this.changeShowPopupContacts({ show: true });
        },
        changeEmail() {
            this.requestChangeContactsEmail({ email: this.payload.email }).then(() => {
                this.$toasted.success(this.$t("successRequestChangeEmail"));
            });
            this.userContactsUpdate = "email";
            this.changeShowPopupContacts({ show: true });
        },
    },
};
